function Footer() {
	return (
		<div className="bg-black text-white text-sm p-5 flex justify-between items-center">
			<div>© Festival d'orgue de Sainte-Marie</div>
		</div>
	);
}

export default Footer;
